import {Locales} from '@netx/core-next/locales';

export const AuthTitle = Locales((i18n) => ({
	FORGOT_PASSWORD: i18n('i18n.forgotPassword'),
	REGISTER: i18n('i18n.register'),
	UPDATE_PASSWORD: i18n('i18n.updatePassword'),
	UPDATE_PASSWORD_SUCCESS: i18n('i18n.success'),
}));

export const AuthActionLabel = Locales((i18n) => ({
	CREATE_ACCOUNT: i18n('i18n.createAccount'),
	REGISTER: i18n('i18n.register'),
	RESET_PASSWORD: i18n('i18n.resetPassword'),
	RETURN_TO_LOGIN: i18n('i18n.returnToLogin'),
	SEND_PASSWORD_RESET_EMAIL: i18n('i18n.sendResetEmail'),
	SIGN_IN: i18n('i18n.signIn'),
	UPDATE_PASSWORD: i18n('i18n.changePassword'),
	CANCEL: i18n('i18n.cancel'),
	EXTERNAL_SUPPLIERS_CLICK_HERE: i18n('i18n.externalSuppliersClickHere'),
}));

export const AuthMessage = Locales((i18n) => ({
	AWAITING_APPROVAL: i18n('i18n.receivedMessage'),
	INVALID_LOGIN: i18n('i18n.loginIncorrect'),
	RESET_PASSWORD_REQUEST: i18n('i18n.passwordStep1Instructions'),
	PASSWORD_RESET_SENT: i18n('i18n.passwordResetEmailSent'),
	PASSWORD_RESET_REQUEST_FAILED: i18n('i18n.couldNotSendPasswordResetEmail'),
	PASSWORD_UPDATE_INSTRUCTIONS: i18n('i18n.passwordChangeInstructions'),
	// TODO: this is a terrible key for this
	PASSWORD_UPDATE_WARNING: (minPasswordLength: number) =>
		i18n('i18n.passwordLength', {count: minPasswordLength}),
	PASSWORD_UPDATE_FAILED: i18n('i18n.couldNotSendResetPassword'),
	PASSOWRD_UPDATED_SIGNIN_REQUIRED: i18n('i18n.passwordChangedLogIn'),
	REGISTRATION_SUCCESS: i18n('i18n.registrationSuccessful'),
	SIGNING_IN: i18n('i18n.signingIn'),
	SIGNED_IN: i18n('i18n.signedInRedirecting'),
	SIGNED_OUT_INACTIVITY: i18n('i18n.youWereLoggedOut'),
}));

export const AuthFieldLabel = Locales((i18n) => ({
	email: i18n('i18n.email'),
	login: i18n('i18n.username'),
	name1: i18n('i18n.firstName'),
	name3: i18n('i18n.lastName'),
	password1: i18n('i18n.password'),
	password2: i18n('i18n.confirmPassword'),
}));
